// extracted by mini-css-extract-plugin
export default {"container":"forecast-table_container__iKmHY","title":"forecast-table_title__RjKeE"};